import { fromEvent } from 'rxjs';

export const onWindowUnload = fromEvent(window, 'unload');
